import { z } from "zod";

export const getLastLocationByCompanyVehiclesResponseSchema = z.array(
  z.object({
    vehicleUuid: z.uuid(),
    lat: z.number(),
    lon: z.number(),
    date: z.iso.datetime(),
  }),
);

export type GetLastLocationByCompanyVehiclesResponse = z.infer<
  typeof getLastLocationByCompanyVehiclesResponseSchema
>;
